if (!customElements.get('mijn-product-gallery')) {
  customElements.define('mijn-product-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.track = this.querySelector('.mijn-gallery__track');
      this.slides = Array.from(this.track.children);
      this.index = 0;
      this.dialog = this.querySelector('dialog');
      const thumbnails = this.querySelector('.mijn-gallery__thumbnails');
      this.thumbs = this.slides.map((slide, index) => {
        const frame = slide.querySelector('.mijn-gallery__frame');
        if (!frame) return null;
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'mijn-gallery__thumb';
        button.setAttribute('aria-label', `${index + 1}: ${slide.querySelector('figcaption')?.textContent.trim() || ''}`);
        button.setAttribute('aria-pressed', index === 0 ? 'true' : 'false');
        const copy = frame.cloneNode(true);
        copy.setAttribute('aria-hidden', 'true');
        button.append(copy);
        button.addEventListener('click', () => this.go(index));
        thumbnails.append(button);
        return button;
      });
      this.querySelector('.mijn-gallery__controls').hidden = this.slides.length < 2;
      thumbnails.hidden = this.slides.length < 2;
      const firstImage = this.slides[0]?.querySelector('img');
      if (firstImage) { firstImage.loading = 'eager'; firstImage.fetchPriority = 'high'; }
      this.querySelectorAll('[data-step]').forEach(button => button.addEventListener('click', () => this.go(this.index + Number(button.dataset.step))));
      this.track.addEventListener('keydown', event => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault(); this.go(this.index + (event.key === 'ArrowRight' ? 1 : -1));
        }
      });
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(this.scrollFrame);
        this.scrollFrame = requestAnimationFrame(() => {
          this.index = Math.min(this.slides.length - 1, Math.max(0, Math.round(this.track.scrollLeft / this.track.clientWidth)));
          this.update();
        });
      }, {passive:true});
      this.slides.forEach(slide => slide.querySelector('.mijn-gallery__zoom')?.addEventListener('click', () => {
        const large = this.querySelector('.mijn-gallery__large');
        large.replaceChildren(slide.querySelector('.mijn-gallery__frame').cloneNode(true));
        const zoomImage = large.querySelector('img');
        zoomImage.loading = 'eager';
        zoomImage.fetchPriority = 'high';
        if (zoomImage.dataset.maxResolution) {
          zoomImage.removeAttribute('srcset');
          zoomImage.removeAttribute('sizes');
          zoomImage.src = zoomImage.dataset.maxResolution;
        }
        this.dialog.showModal();
      }));
      this.querySelector('.mijn-gallery__close').addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('click', event => { if (event.target === this.dialog) this.dialog.close(); });
      this.update();
    }
    go(index) {
      this.index = (index + this.slides.length) % this.slides.length;
      this.track.scrollTo({left:this.index * this.track.clientWidth, behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      this.update();
    }
    update() {
      this.querySelector('.mijn-gallery__counter').textContent = `${this.index + 1} / ${this.slides.length}`;
      this.thumbs.forEach((thumb, index) => thumb?.setAttribute('aria-pressed', index === this.index ? 'true' : 'false'));
    }
    disconnectedCallback() { cancelAnimationFrame(this.scrollFrame); }
  });
}
